"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Heading_meta_1 = require("../Heading.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('h4', Heading_meta_1.HEADING_CATEGORY_KEY, Heading_meta_1.HEADING_COMPONENT_KEY, ['h4']);